import { useQuery } from "@tanstack/react-query";
import { useApi } from "hooks"

const useGetLangs = () => {

  const { apiFetch } = useApi()

  const url = `/langs`;

  const getLangs = () => {
    return apiFetch({ url }).then( res => res.data)
  }

  const options = {
    staleTime: Infinity,
    placeholderData: [],
  }

  return useQuery(['langs'], getLangs, options)
}

export default useGetLangs